const A2A = () => {
  return (
    <svg
      width="48"
      height="32"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.391 4.666H5.667C5.299 4.666 5 4.368 5 4C5 3.631 5.299 3.333 5.667 3.333H13.391L11.196 1.138C10.936 0.878 10.936 0.455 11.196 0.195C11.456 -0.065 11.878 -0.065 12.138 0.195L15.472 3.528C15.732 3.788 15.732 4.211 15.472 4.471L12.138 7.804C11.878 8.064 11.456 8.064 11.196 7.804C10.936 7.544 10.936 7.122 11.196 6.862L13.391 4.666Z"
        fill="#1F1F68"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.28331 8.35145L10.0073 8.33444C10.3753 8.33363 10.675 8.63097 10.6758 8.99897C10.6766 9.36797 10.3782 9.66663 10.0102 9.66744L2.28625 9.68445L4.48608 11.8746C4.74665 12.134 4.74758 12.557 4.48816 12.8176C4.22873 13.0782 3.80673 13.0791 3.54616 12.8197L0.204826 9.49403C-0.0557461 9.23461 -0.0566777 8.81161 0.202749 8.55104L3.5294 5.2107C3.78883 4.95013 4.21083 4.9492 4.4714 5.20863C4.73197 5.46805 4.7329 5.89005 4.47347 6.15062L2.28331 8.35145Z"
        fill="#1F1F68"
        fillOpacity="0.5"
      />
    </svg>
  )
}

export default A2A
